export default [
  'Constitution date',
  'Number of new shares',
  'Shares nominal value',
];
